import { action } from 'satcheljs';
import { AccountProviderType, OWAConnectedAccount } from 'owa-accounts-store';
import { addDatapointConfig } from 'owa-analytics-actions';

/**
 * Connect a new account for OWA
 */
export const connectOWAAccount = action(
    'connectAccount',
    (accountProviderType: AccountProviderType, source: string, isReconnectFlow: boolean = false) =>
        addDatapointConfig(
            {
                name: 'connectAccount',
                options: {
                    isCore: true,
                },
                customData: {
                    accountProviderType_1: accountProviderType,
                    source_2: source,
                },
            },
            {
                accountProviderType,
                source,
                isReconnectFlow,
            }
        )
);

/**
 * Disconnect an account for OWA
 */
export const disconnectOWAAccount = action(
    'disconnectAccount',
    (account: OWAConnectedAccount, source: string, isReconnectFlow: boolean = false) =>
        addDatapointConfig(
            {
                name: 'disconnectOWAAccount',
                options: {
                    isCore: true,
                },
                customData: {
                    accountProviderType_1: account.accountProviderType,
                    source_2: source,
                },
            },
            {
                account,
                source,
                isReconnectFlow,
            }
        )
);

/**
 * Announces when an attempt to connect a new OWA connected account has failed
 */
export const connectOWAConnectedAccountFailed = action(
    'connectOWAConnectedAccountFailed',
    (
        isReconnectFlow: boolean = false,
        errorType: string,
        accountProviderType: AccountProviderType,
        source: string
    ) =>
        addDatapointConfig(
            {
                name: 'connectOWAConnectedAccountFailed',
                options: {
                    isCore: true,
                },
                customData: {
                    errorType_1: errorType,
                    source_2: source,
                    accountProviderType_3: accountProviderType,
                },
            },
            {
                isReconnectFlow,
                errorType,
                source,
                accountProviderType,
            }
        )
);

/**
 * Announces when an attempt to disconnect a new OWA connected account has failed
 */
export const disconnectOWAConnectedAccountFailed = action(
    'disconnectOWAConnectedAccountFailed',
    (isReconnectFlow: boolean = false) => ({
        isReconnectFlow,
    })
);

/**
 * Announces when an OWA Connected account has been disconncted
 */
export const connectedAccountDisconnected = action(
    'connectedAccountDisconnected',
    (userIdentity: string, isReconnectFlow: boolean = false) => ({
        userIdentity,
        isReconnectFlow,
    })
);

/**
 * Announces when an OWA Connected account has been connected
 */
export const accountConnected = action(
    'accountConnected',
    (
        userIdentity: string,
        accountProviderType: AccountProviderType,
        accountUniqueId: string,
        source: string
    ) =>
        addDatapointConfig(
            {
                name: 'accountConnected',
                options: {
                    isCore: true,
                },
                customData: {
                    accountProviderType_1: accountProviderType,
                    source_2: source,
                },
            },
            {
                userIdentity,
                accountProviderType,
                accountUniqueId,
                source,
            }
        )
);
